module.exports = __webpack_public_path__ + "static/media/it.d3ad8488.svg";